



export const vcPacks1 = [
  {
    amount: 1,

    currency: 'bronze',

    "id": 37783,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png",
    "label": null,
    "advertisement_type": "special_offer",
    "advertisement_type_custom": null,
    sku: "kg_2",
    description: {
      "en": "Tiny amount of USD!"
    },
    bonus: 0,
    enabled: true,
    prices_array: [
      {
        "name": "USD",
        "value": 19.99
      }
    ]
  },
]





export const vcPacks3 =  [
  {
    amount: 3,
    "id": 37783,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png",
    "label": null,
    "advertisement_type": "special_offer",
    "advertisement_type_custom": null,
    sku: "kg_2",
    description: {
      "en": "Regular amount of USD!"
    },
    bonus: 0,
    enabled: true,
    prices_array: [
      {
        "name": "USD",
        "value": 19.99
      }
    ]
  },
  {
    amount: 8,
    "id": 37782,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png",
    "label": null,
    "advertisement_type": "recommended",
    "advertisement_type_custom": null,
    sku: "kg_1",
    description: {
      "en": "A small amount of KG."
    },
    bonus: 0.099,
    enabled: true,
    prices_array: [
      {
        "name": "USD",
        "value": 9.99
      }
    ]
  }
]



export const vcPacks2 = [
  {
    amount: 1,
    "id": 37783,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    "label": null,
    "advertisement_type": "special_offer",
    "advertisement_type_custom": null,
    sku: "kg_2",
    description: {
      "en": "10 Gold Coins"
    },
    bonus: 0.035,
    enabled: true,
    prices_array: [
      {
        "name": "USD",
        "value": 1.99
      }
    ]
  },
  {
    amount: 4,
    "id": 37782,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    "label": null,
    "advertisement_type": "recommended",
    "advertisement_type_custom": null,
    sku: "kg_1",
    description: {
      "en": "100 Gold Coins"
    },
    bonus: 0.099,
    enabled: true,
    prices_array: [
      {
        "name": "USD",
        "value": 9.99
      }
    ]
  },
  {
    amount: 18,
    "id": 39311,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    "label": null,
    "advertisement_type": "recommended",
    "advertisement_type_custom": null,
    sku: "kg_3",
    description: {
      "en": "300 Gold Coins"
    },
    bonus: 0.01,
    enabled: true,
    prices_array: [
      {
        "name": "USD",
        "value": 19.99
      }
    ]
  }
]






export const vc = [
  {
    id: 'BRZ',
    title: 'Bronze Coins',
    hard: true,
    packs: [...vcPacks1],

    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png",
    sku: "BRZ",
    description: {
      "en": "kg_2"
    },
    bonus: 0,
    prices_array: [
      {
        "name": "USD",
        "value": 19.99
      }
    ],
    enabled: true,

  },
  {
    id: 'silver',
    title: 'Silver Coins',
    hard: true,
    packs: [...vcPacks2],

    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png",
    sku: "silver",
    description: {
      "en": "A small amount of KG."
    },
    prices_array: [
      {
        "name": "USD",
        "value": 9.99
      }
    ],
    enabled: true,
  },
  {
    id: 'gold',
    packs: [...vcPacks3],
    title: 'Golden Coins',
    hard: true,
    sku: "gold",
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    description: {
      "en": "A large amount of USD!"
    },
    prices_array: [
      {
        "name": "USD",
        "value": 99.99
      }
    ],
    enabled: true,
  }
];






export const currencies = [
  {
    id: 'BRZ',
    title: 'Bronze Coins',
    hard: true,
    packs: [...vcPacks1],

    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png",
    sku: "BRZ",
    description: {
      "en": "kg_2"
    },
    bonus: 0,
    prices_array: [
      {
        "name": "USD",
        "value": 19.99
      }
    ],
    enabled: true,

  },
  {
    id: 'silver',
    title: 'Silver Coins',
    hard: true,
    packs: [...vcPacks2],

    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png",
    sku: "silver",
    description: {
      "en": "A small amount of KG."
    },
    prices_array: [
      {
        "name": "USD",
        "value": 9.99
      }
    ],
    enabled: true,
  },
  {
    id: 'gold',
    packs: [...vcPacks3],
    title: 'Golden Coins',
    hard: true,
    sku: "gold",
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    description: {
      "en": "A large amount of USD!"
    },
    prices_array: [
      {
        "name": "USD",
        "value": 99.99
      }
    ],
    enabled: true,
  }
];




export const currsReal = {

  USD: {
    real: true,
    id: 'USD',
    title: 'USD',
    titleMultiple: 'USD',
    hard: true,
    packs: [...vcPacks2],

    // image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png",
    sku: "USD",
    description: {
      "en": "A small amount of KG."
    },
    prices_array: [
      {
        "name": "USD",
        "value": 9.99
      }
    ],
    enabled: true,

    prices: {
      USD: '1',
      gold: '10',
      silver: '9.99',
      BRZ: '19.99',
    },
  }
}



export const currs = {

  // USD: {
  //   real: true,
  //   id: 'USD',
  //   title: 'USD',
  //   titleMultiple: 'USD',
  //   hard: true,
  //   packs: [...vcPacks2],

  //   // image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png",
  //   sku: "silver",
  //   description: {
  //     "en": "A small amount of KG."
  //   },
  //   prices_array: [
  //     {
  //       "name": "USD",
  //       "value": 9.99
  //     }
  //   ],
  //   enabled: true,

  //   prices: {
  //     USD: '1',
  //     gold: '10',
  //     silver: '9.99',
  //     BRZ: '19.99',
  //   },

  // },

  BRZ: {
    id: 'BRZ',
    title: 'Bronze Coin',
    titleMultiple: 'Bronze Coins',
    hard: true,
    packs: [...vcPacks1],

    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/40a074e3b025cb56b8bb630da6989481.png",
    sku: "BRZ",
    description: {
      "en": "kg_2"
    },
    bonus: 0,
    prices_array: [
      {
        "name": "USD",
        "value": 19.99
      }
    ],
    enabled: true,
    prices: {
      USD: '199',
      gold: '1',
      silver: '9.99',
      BRZ: '19.99',
    },
  },


  silver: {
    id: 'silver',
    title: 'Silver Coin',
    titleMultiple: 'Silver Coins',
    hard: true,
    packs: [...vcPacks2],

    image_url: "http://cdn3.xsolla.com/img/misc/images/8ca4bc6933bf8a252ad6fed162027212.png",
    sku: "silver",
    description: {
      "en": "A small amount of KG."
    },
    prices_array: [
      {
        "name": "USD",
        "value": 9.99
      }
    ],
    enabled: true,

    prices: {
      USD: '199',
      gold: '1',
      silver: '9.99',
      BRZ: '19.99',
    },

  },
  gold: {
    id: 'gold',
    packs: [...vcPacks3],
    title: 'Golden Coin',
    titleMultiple: 'Golden Coins',
    hard: true,
    sku: "gold",
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    description: {
      "en": "A large amount of USD!"
    },
    prices_array: [
      {
        "name": "USD",
        "value": 99.99
      }
    ],

    prices: {
      USD: '199',
      gold: '1',
      silver: '9.99',
      BRZ: '19.99',
    },



    enabled: true,
  }

};




export const vcpacks = {
  bronzePack1: {
    amount: 5,
    title: 'Bronze coins',
    // image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
    currencySku: 'BRZ',
    description: {
      en: ''
    },
    prices: {
      USD: null,
      gold: '1.99',
      BRZ: '9.99',
      silver: '19.99',
    }
  },


  silverPack1: {
    currencySku: 'silver',
    title: 'One Silver',
    amount: 1,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png",
    description: {
      en: ''
    },
    prices: {
      USD: '13.99',
      gold: null,
      BRZ: '9.99',
      silver: '19.99',
    }
  },


  goldPack1: {
    currencySku: 'gold',
    title: 'Some Gold Coins',
    amount: 10,
    image_url: null, //берется дефолтная картинка валюты
    description: {
      en: ''
    },
    prices: {
      USD: '0.99',
      gold: '1.99',
      BRZ: null,
      silver: '19.99',
    }
  },
  goldPack2: {
    currencySku: 'gold',
    title: 'Great deal of Gold Coins',
    amount: 100,
    // image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png", //кастомная картинка для пака
    description: {
      en: ''
    },
    prices: {
      USD: '4.99',
      gold: '1.99',
      BRZ: '9.99',
      silver: '18.99',
    }
  },


}


export const currDef = {
    id: 'new',
    title: 'New Coin',
    titleMultiple: 'New Coins',
    hard: true,
    packs: [...vcPacks1],

    image_url: "https://res.cloudinary.com/maiik/image/upload/v1574290830/xsolla_paystation_0_h8ld4m.svg",
    sku: "new",
    description: {
      // "en": "kg_2"
    },
    bonus: 0,
    prices_array: [
      {
        "name": "NEW",
        "value": 19.99
      }
    ],
    enabled: true,
    prices: {
      USD: '199',
      gold: '1',
      silver: '9.99',
      BRZ: '19.99',
    },
}


export const vcDef = {
  newCurrency: {
    title: 'New currency name',
    amount: 10,
    currencySku: 'gold',
    image_url: null, //берется дефолтная картинка валюты
    description: {
      en: ''
    },
    prices: {
      USD: '0.99',
      gold: '1.99',
      BRZ: '9.99',
      silver: '19.99',
    }
  },
  goldPack2: {
    title: 'Great deal of Gold Coins',
    amount: 100,
    currencySku: 'gold',
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png", //кастомная картинка для пака
    description: {
      en: ''
    },
    prices: {
      USD: '4.99',
      gold: '1.99',
      BRZ: '9.99',
      silver: '19.99',
    }
  },
  silverPack1: {
    title: 'Some Silver',
    amount: 1,
    image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/8ca4bc6933bf8a252ad6fed162027212.png",
    currencySku: 'silver',
    description: {
      en: ''
    },
    prices: {
      USD: '13.99',
      gold: '1.99',
      BRZ: '9.99',
      silver: '19.99',
    }
  },
  // bronzePack1: {
  //   amount: 5,
  //   title: 'Bronze coins',
  //   image_url: "\/\/cdn3.xsolla.com\/img\/misc\/images\/e0c58028450a6e880f0d2bb67399f167.png",
  //   currencySku: 'gold',
  //   description: {
  //     en: ''
  //   },
  //   prices: {
  //     USD: '18.99',
  //     gold: '1.99',
  //     BRZ: '9.99',
  //     silver: '19.99',
  //   }
  // },
}